<template>
    <div>
        <v-form ref="relations_data_form">
            <!-- <v-container fluid pa-0 v-if="requiredCategoriesMissing.length > 0">
                <v-layout row>
                    <v-flex xs12 mx-2 mb-2 mt-1 class="fw-bold fs-18">{{ $t('lang.station_must_have_procedure') }}</v-flex>
                </v-layout>
            </v-container> -->
            <v-card v-if="required_categories_missing.length > 0" style="background-color: rgba(255, 0, 0, .3) !important;">
                    <div class="pa-2">
                        <div class="subheading">Missing Required Files</div>
                        <div class="headline">{{ required_categories_missing.join(', ') }}</div>
                    </div>
            </v-card>
            <v-data-table
                :key="update_table"
                :headers="headers"
                :items="parts_files || []"
                hide-actions
                :no-data-text="$t('lang.no_data_available')"
                :class="{ 'prevent-click': !hasPerm('parts.update') }"
            >
                <template slot="items" slot-scope="props">
                    <tr class="clickable" @mouseup.left="showPartFile(props.item)">
                        <td class="text-center" @mouseup.left.stop="showImage(props.item)">
                            <v-icon v-if="props.item.type == 'pdf'" >picture_as_pdf</v-icon>
                            <img
                                v-else
                                :src="props.item.thumb_path"
                                @error="imageLoadError"
                                style="max-width:50px; max-height:50px;"
                            />
                        </td>
                        <td>{{ props.item.comments || $t('lang.none') }}</td>
                        <td>{{ props.item.category || $t('lang.none') }}</td>
                        <td>{{ props.item.created_by || $t('lang.none') }}</td>
                        <td>{{ props.item.date_created || $t('lang.none') }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-form>
        <bc-dialog :value="files_dialog" max-width="700">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ currFileField('file_id') ? $t('lang.edit_file') : $t('lang.add_file') }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        action="closePartFileDialog"
                        :dialog-status="files_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="part_file">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <!-- <v-flex xs12 v-if="!currFileField('file_id')" class="clickable" @click="pickFile">
                                    <span v-if="!imageUrl" class="title text-center my-auto">{{ $t('lang.browse') }}</span>
                                    <div v-else>
                                        <img :src="imageUrl" class="pb-1" style="object-fit: contain" :style="$bp.smAndUp ? 'max-width: 600px; max-height: 600px' : 'max-width: 300px; max-height: 300px'" />
                                    </div>
                                </v-flex> -->
                                <v-flex xs12 v-if="!currFileField('file_id')" style="height:60px;" class="clickable" @click="pickFile">
                                    <v-text-field
                                        v-model="imageName"
                                        label="Select Image"
                                        prepend-icon="attach_file"
                                        solo
                                        flat
                                        outline
                                        readonly
                                        class="clickable"
                                    ></v-text-field>
                                    <input
                                        :key="reload_file"
                                        type="file"
                                        style="display: none"
                                        ref="image"
                                        accept=".doc, .docx, .xls, .xlsx, .xlsm, .pdf, .jpg, .jpeg, .png, .gif, .tiff, .bmp"
                                        @input="onFilePicked"
                                    >
                                </v-flex>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        v-model="part_file.category_id"
                                        :label="`${$t('lang.category')} *`"
                                        :items="files_categories"
                                        item-value="category_id"
                                        item-text="category"
                                        :rules="ifValid('part_file.category_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="part_file.comments"
                                        :label="$t('lang.comments')"
                                        :counter="showCounter(part_file.comments, 'part_file.comments')"
                                        :rules="ifValid('part_file.comments')"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="currFileField('file_id') && hasPerm('parts.delete')" color="error" @mouseup.left="$refs.delete_part_file.openDialog()">{{ $t('lang.delete') }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closePartFileDialog()">{{$t('lang.cancel')}}</v-btn>
                    <v-btn color="success" :disabled="!imageUrl && !currFileField('file_id')" @mouseup.left="currFileField('file_id') ? modifyPartFile('patch', currFileField('file_id')) : addPartFile()">{{$t('lang.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-dialog :value="view_file_dialog" :max-width="currFileField('type') == 'pdf' ? '1450' : '650'">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t('lang.file_viewer') }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        action="closeViewFileDialog"
                        :dialog-status="view_file_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text class="pa-0">
                    <iframe v-if="currFileField('type') == 'pdf'" :style="frameDimensions" id="print" :src="currFileField('full_path')"></iframe>
                    <img v-else :style="frameDimensions" id="view_file" :src="currFileField('full_path')"/>
                </v-card-text>
            </v-card>
        </bc-dialog>
        <delete-confirmation-dialog
            ref="delete_part_file"
            :heading="$t('lang.delete_part_file')"
            :message="$t('lang.confirm_delete_message')"
            @onConfirm="modifyPartFile('delete', currFileField('file_id'))"
        ></delete-confirmation-dialog>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";
import AppConfig from "Constants/AppConfig";

export default {
    data() {
        return {
            headers: [
                { text: "", sortable: false, width: "15%" },
                { text: this.$t("lang.comments"), sortable: false, width: "25%" },
                { text: this.$t("lang.category"), sortable: false, width: "20%" },
                { text: this.$t("lang.created_by"), sortable: false, width: "20%" },
                { text: this.$t("lang.date_created"), sortable: false, width: "20%" },
            ],
            part_file: {
                comments: "",
                category_id: "",
            },
            files_dialog: false,
            view_file_dialog: false,
            current_file: null,
            imageName: "",
            imageUrl: null,
            reload_file: 0,
            update_table: 0,
            required_categories_missing: [],
        };
    },
    activated() {
        if (this.files_categories == null) {
            this.getFilesCategories();
        } else {
            this.setRequiredCategoriesMissing();
        }
    },
    computed: {
        ...mapState({
            parts_files: (state) => state.parts.parts_files,
            files_categories: (state) => state.parts.files_categories,
            rules_part_file: (state) => state.validation.rules_file,
        }),
        currFileField() {
            return (field) => {
                return this.current_file && field && this.current_file[field] ? this.current_file[field] : "";
            };
        },
        frameDimensions() {
            return {
                "object-fit": "contain",
                "border-width": "0px",
                width: "100%",
                height: this.$bp.mdAndUp ? "calc(100vh - 250px)" : this.$bp.smAndUp ? "calc(100vh - 78px)" : "calc(100vh - 74px)",
            };
        },
        requiredCategoriesMissing() {
            if (this.files_categories) {
                let required_categories = this.files_categories.filter((c) => c.required == "1");
                let existing_categories = this.parts_files ? this.parts_files.map((file) => file.category) : [];
                if (existing_categories.length > 0) required_categories = required_categories.filter((r) => !existing_categories.includes(r.category));
                return required_categories.map((category) => category.category);
            } else {
                return [];
            }
        },
    },
    methods: {
        setRequiredCategoriesMissing() {
            if (this.files_categories) {
                let required_categories = this.files_categories.filter((c) => c.required == "1");
                let existing_categories = this.parts_files ? this.parts_files.map((file) => file.category) : [];
                if (existing_categories.length > 0) required_categories = required_categories.filter((r) => !existing_categories.includes(r.category));
                this.required_categories_missing = required_categories.map((category) => category.category);
            } else {
                this.required_categories_missing = [];
            }
        },
        onFilePicked(e) {
            const files = e.target.files;
            if (files[0] !== undefined) {
                this.imageName = files[0].name;
                if (this.imageName.lastIndexOf(".") <= 0) {
                    return;
                }
                const fr = new FileReader();
                fr.readAsDataURL(files[0]);
                fr.addEventListener("load", () => {
                    this.imageUrl = fr.result;
                });
            }
        },
        pickFile() {
            this.$refs.image.click();
        },
        imageLoadError(event) {
            event.target.src = AppConfig.baseApiUrl + "/public/users/default.png";
        },
        closePartFileDialog() {
            this.imageUrl = null;
            this.files_dialog = false;
            this.$refs.delete_part_file.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        modifyPartFile(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("part_file")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchPart", {
                                pk: "file_id",
                                id: id,
                                url: `parts/${this.$route.params.id}/files/${id ? id : ""}`,
                                method: method,
                                stateProperty: "parts_files",
                                mutate: true,
                                body: this.part_file,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.setRequiredCategoriesMissing();
                                    this.update_table++;
                                    this.closePartFileDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        addPartFile() {
            console.log("addpartfile");
            this.$store.commit("validationOn");
            this.$nextTick(() => {
                if (this.validateForm("part_file") && this.imageUrl) {
                    if (this.imageUrl) this.part_file.file = this.imageUrl;
                    this.$store.commit("toggleModalLoader", true);
                    this.$store
                        .dispatch("fetchPart", {
                            url: `parts/${this.$route.params.id}/files`,
                            method: "post",
                            stateProperty: "parts_files",
                            mutate: true,
                            body: this.part_file,
                        })
                        .then((data) => {
                            if (data && data.code == "200") {
                                this.setRequiredCategoriesMissing();
                                this.update_table++;
                                this.closePartFileDialog();
                                if (this.part_file.file) delete this.part_file.file;
                                this.imageUrl = null;
                            } else {
                                this.$store.commit("toggleModalLoader", false);
                            }
                        });
                }
            });
        },
        showPartFile(item = null) {
            this.reload_file++;
            this.current_file = item;

            if (this.$refs.part_file) item ? this.$refs.part_file.resetValidation() : this.$refs.part_file.reset();

            this.$nextTick(() => {
                this.assignObj(this.part_file, item, this.rules_part_file);
                this.files_dialog = true;
            });
        },
        getFilesCategories() {
            this.$store
                .dispatch("fetchPart", {
                    url: "files_categories",
                    method: "get",
                    stateProperty: "files_categories",
                    commit: true,
                })
                .then((data) => {
                    this.setRequiredCategoriesMissing();
                });
        },
        showImage(file) {
            this.current_file = file;
            this.view_file_dialog = true;
        },
        closeViewFileDialog() {
            this.current_file = null;
            this.view_file_dialog = false;
        },
    },
};
</script>
